import { render } from "./Tagger.vue?vue&type=template&id=4a909262&scoped=true"
import script from "./Tagger.vue?vue&type=script&lang=js"
export * from "./Tagger.vue?vue&type=script&lang=js"

import "./Tagger.vue?vue&type=style&index=0&id=4a909262&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a909262"]])

export default __exports__